import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {PbCertificateComponent} from './pb.component';
import {ObjectsModalSelectModule} from '@components/objects-modal-select/objects-modal-select.module';
import {LayoutModule} from '../../layout-components/layout.module';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {IconsModule} from '@lab365/icons';

/**
 * Модуль удостоверения ПБ
 */
@NgModule({
    declarations: [PbCertificateComponent],
    exports: [PbCertificateComponent],
    imports: [
        LayoutModule,
        CommonModule,
        ReactiveFormsModule,
        FormFieldModule,
        ObjectsModalSelectModule,
        FilesUploaderModule,
        IconsModule,
    ],
    providers: []
})
export class CertificatePbModule {}
